import { ErrorCode, MAX_FILE_SIZE } from "@consts/index";
import { bytesToSize } from "@covertree/utils";
import { isDocumentFromSocotra } from "@utils/isDocumentFromSocotra";

export interface UploadPolicyDocumentsForm {
  files: File[];
  signedManually: boolean;
}

export const defaultValues: UploadPolicyDocumentsForm = {
  files: [],
  signedManually: false,
};

export const validator = (file: File) => {
  if (isDocumentFromSocotra(file.name)) {
    return {
      code: ErrorCode.InvalidName,
      message: `The file "${file.name}" cannot be uploaded. Its name is reserved for auto-generated documents.`,
    };
  }

  if (file.size > MAX_FILE_SIZE) {
    return {
      code: ErrorCode.FileTooBig,
      message: `You cannot add file larger than ${bytesToSize(MAX_FILE_SIZE)}.`,
    };
  }

  return null;
};
